import type {EventHandler, EventType} from "../index";
import {ConnectionAliveEvent} from "../index";
import store from "../../../configureStore";
import {DMS_CONNECTION_PING} from "../../action";

export const ConnectionAliveEventHandler: EventHandler = {
	handles(eventType: EventType): boolean {
		return eventType === "CONNECTION_ALIVE";
	},
	handle(event: ConnectionAliveEvent) {
		store.dispatch({
			type: DMS_CONNECTION_PING.SUCCESS,
			payload: event
		});
	}
};